"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DraggingParameterApi_parameter;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDraggingParameterApi = exports.DraggingParameterApi = void 0;
const ParameterApi_1 = require("./ParameterApi");
class DraggingParameterApi extends ParameterApi_1.ParameterApi {
    constructor(parameter) {
        super(parameter);
        _DraggingParameterApi_parameter.set(this, void 0);
        __classPrivateFieldSet(this, _DraggingParameterApi_parameter, parameter, "f");
    }
    get interactionType() {
        return __classPrivateFieldGet(this, _DraggingParameterApi_parameter, "f").interactionType;
    }
    get settings() {
        return __classPrivateFieldGet(this, _DraggingParameterApi_parameter, "f").settings;
    }
}
exports.DraggingParameterApi = DraggingParameterApi;
_DraggingParameterApi_parameter = new WeakMap();
const isDraggingParameterApi = (obj) => obj instanceof DraggingParameterApi;
exports.isDraggingParameterApi = isDraggingParameterApi;
//# sourceMappingURL=DraggingParameterApi.js.map